<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <b-form @submit.stop.prevent="guardar">
      <div>
        <b-tabs class="mr-3 ml-3">
          <b-tab class="p-0">
            <template #title>
              Datos de la Clínica
              <em class="admiracion" variant="danger" v-show="tab1Vacio" ></em>
            </template>

            <b-row>
              <b-col>
                <p style="color: #17a2b8; font-weight: 600" class="mt-2">Datos de  Clínica</p>
              </b-col>
            </b-row>
            <div class="scrollPorTabs">
            <b-row cols="1" cols-md="2" cols-lg="4" class="mr-3">
              <b-col>
                <b-form-group align="left">
                  <label>Nombre de la clínica
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="idNombre"
                        placeholder="Ingresa el nombre de la clínica"
                        :state="validateState('strNombre')"
                        v-model="$v.objGuardar.strNombre.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Nombre corto
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="idNombreCorto"
                        placeholder="Ingresa el nombre corto"
                        :state="validateState('strNombreCorto')"
                        v-model="$v.objGuardar.strNombreCorto.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Número de sillones
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="idNombreCorto"
                        placeholder="Ingresa número de sillones"
                        :state="validateState('numeroSillones')"
                        v-model="$v.objGuardar.numeroSillones.$model"
                        type="number"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Capacidad
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="idNombreCorto"
                        placeholder="Ingresa la capacidad"
                        :state="validateState('capacidad')"
                        v-model="$v.objGuardar.capacidad.$model"
                        type="number"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>IdCRM
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="idNombre"
                        placeholder="Ingresa el id del CRM"
                        :state="validateState('idCrm')"
                        v-model="$v.objGuardar.idCrm.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left" s>
                  <label>Tipo SDI<validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        style="width: 100%;"
                        label="descripcion"
                        id="tipoSDIComp"
                        :options="opcionesTiposSDIFiltro"
                        :reduce="(val) => val.idTipoSdi"
                        v-model="$v.objGuardar.idTipoSdi.$model"
                        placeholder="Selecciona un tipo de SDI"

                        :filterable="false"
                        @search="filtroOpcionesTiposSDI"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idTipoSdi.$dirty && ($v.objGuardar.idTipoSdi.$invalid || $v.objGuardar.idTipoSdi.$error == 'true')"
                        texto="Selecciona un tipo de SDI"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <div class="formularios marginformularios"
                     style="display:flex;align-items:center">
                  <label class="bold marginlabel"
                         style="margin-top:5px"
                  >¿Está activa en web?</label>
                  <b-form-checkbox
                      id="activoWeb"
                      class="formularios marginformularios"
                      v-model="$v.objGuardar.blnWeb.$model"
                      :state="validateState('blnWeb')"
                      value="true"
                      unchecked-value="false"
                      switch
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Latitud
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="idLatitudComp"
                        placeholder="Ingresa la latitud"
                        :state="validateState('strLatitud')"
                        v-model="$v.objGuardar.strLatitud.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Longitud
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="idLatitudComp"
                        placeholder="Ingresa la longitud"
                        :state="validateState('strLongitud')"
                        v-model="$v.objGuardar.strLongitud.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Zona precios
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2 redondeo">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        label="nombreZona"
                        id="preciosComp"
                        :options="opcionesPreciosFiltro"
                        :reduce="(val) => val.idPrecio"
                        v-model="$v.objGuardar.idPrecio.$model"
                        placeholder="Selecciona un precio"

                        :filterable="false"
                        @search="filtroOpcionesPrecios"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idPrecio.$dirty && ($v.objGuardar.idPrecio.$invalid || $v.objGuardar.idPrecio.$error == 'true')"
                        texto="Selecciona un precio"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Ubicación
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        label="descripcion"
                        id="ubicacionComp"
                        :options="opcionesUbicacionesFiltro"
                        :reduce="(val) => val.idUbicacion"
                        v-model="$v.objGuardar.idUbicacion.$model"
                        placeholder="Selecciona una ubicación"
                        :filterable="false"
                        @search="filtroOpcionesUbicaciones"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idUbicacion.$dirty && ($v.objGuardar.idUbicacion.$invalid || $v.objGuardar.idUbicacion.$error == 'true')"
                        texto="Selecciona la ubicación"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Región
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        label="zona_nombre"
                        id="zonaComp"
                        :options="opcionesZonasFiltro"
                        :reduce="(val) => val.idZona"
                        v-model="$v.objGuardar.idZona.$model"
                        placeholder="Selecciona una región"

                        :filterable="false"
                        @search="filtroOpcionesZonas"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idZona.$dirty && ($v.objGuardar.idZona.$invalid || $v.objGuardar.idZona.$error == 'true')"
                        texto="Selecciona la región"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>K clínica
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        maxlength="5"
                        oninput="if(this.value.length > this.maxlength) this.value = this.value.slice(0, this.maxlength);"
                        id="kClinicaComp"
                        placeholder="Ingresa la k clínica"
                        :state="validateState('idKcli')"
                        v-model="$v.objGuardar.idKcli.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>K región
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        maxlength="3"
                        oninput="if(this.value.length > this.maxlength) this.value = this.value.slice(0, this.maxlength);"
                        id="kRegionComp"
                        placeholder="Ingresa la k región"
                        :state="validateState('kRegion')"
                        v-model="$v.objGuardar.kRegion.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>K unit Prod
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="kUnitProdComp"
                        maxlength="3"
                        oninput="if(this.value.length > this.maxlength) this.value = this.value.slice(0, this.maxlength);"
                        placeholder="Ingresa la k unidad prod"
                        :state="validateState('kunitProd')"
                        v-model="$v.objGuardar.kunitProd.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>K sub cliente
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        maxlength="7"
                        oninput="if(this.value.length > this.maxlength) this.value = this.value.slice(0, this.maxlength);"
                        id="kUnitProdComp"
                        placeholder="Ingresa la k sub cliente"
                        :state="validateState('kSubClient')"
                        v-model="$v.objGuardar.kSubClient.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Tipo de clínica
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        label="descripcion"
                        id="idTipoClinicaComp"
                        :options="opcionesTipoClinicaFiltro"
                        :reduce="(val) => val.idTipoClinica"
                        v-model="$v.objGuardar.idTipoClinica.$model"
                        placeholder="Selecciona un tipo de clínica"

                        :filterable="false"
                        @search="filtroOpcionesTipoClinica"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idTipoClinica.$dirty && ($v.objGuardar.idTipoClinica.$invalid || $v.objGuardar.idTipoClinica.$error == 'true')"
                        texto="Selecciona un tipo de clínica"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>RFC
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-form-input
                        class="redondeo"
                        id="kUnitProdComp"
                        placeholder="Ingresa el RFC"
                        :state="validateState('strRFC')"
                        v-model="$v.objGuardar.strRFC.$model"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Categoría de clínica
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        label="descripcion"
                        id="idCategoriaClinica"
                        :options="opcionesCategoriaClinicaFiltro"
                        :reduce="(val) => val.idCategoria"
                        v-model="$v.objGuardar.idCategoria.$model"
                        placeholder="Categoría a la que pertenece la clínica"
                        :filterable="false"
                        @search="filtroOpcionesCategoriaClinica"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idCategoria.$dirty && ($v.objGuardar.idCategoria.$invalid || $v.objGuardar.idCategoria.$error == 'true')"
                        texto="Selecciona una categoría de clínica"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group align="left">
                  <label>Zona Horaria
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        label="nombreZona"
                        id="idZonaHoraria"
                        :options="opcionesZonasHorariasFiltro"
                        :reduce="(val) => val.idZonaHoraria"
                        v-model="$v.objGuardar.idZonaHoraria.$model"
                        placeholder="Zona horaria de la clínica"
                        :filterable="false"
                        @search="filtroOpcionesZonasHorarias"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.idZonaHoraria.$dirty && ($v.objGuardar.idZonaHoraria.$invalid || $v.objGuardar.idZonaHoraria.$error == 'true')"
                        texto="Zona horaria de la clínica"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <div class="formularios marginformularios"
                     style="display:flex;align-items:center">
                  <label class="bold marginlabel"
                         style="margin-top:5px"
                  >¿Registra ingresos?</label>
                  <b-form-checkbox
                      id="registraIngComp"
                      class="formularios marginformularios"
                      v-model="$v.objGuardar.blnRegistraIngresos.$model"
                      :state="validateState('blnRegistraIngresos')"
                      value="true"
                      unchecked-value="false"
                      switch
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col>
                <div class="formularios marginformularios"
                     style="display:flex;align-items:center">
                  <label class="bold marginlabel"
                         style="margin-top:5px"
                  >¿Tiene escáner fits?</label>
                  <b-form-checkbox
                      id="tieneScanerFitsComp"
                      class="formularios marginformularios"
                      v-model="$v.objGuardar.escanerFits.$model"
                      :state="validateState('escanerFits')"
                      value="true"
                      unchecked-value="false"
                      switch
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col>
                <div class="formularios marginformularios"
                     style="display:flex;align-items:center">
                  <label class="bold marginlabel"
                         style="margin-top:5px"
                  >¿Tiene escáner para labortatorio?</label>
                  <b-form-checkbox
                      id="tieneScanerLaboratorio"
                      class="formularios marginformularios"
                      v-model="$v.objGuardar.tieneEscanerLaboratorio.$model"
                      :value="true"
                      :unchecked-value="false"
                      switch
                      @input="objGuardar.idEscanerLaboratorio = null;"
                  ></b-form-checkbox>
                </div>
              </b-col>

              <b-col>
                <b-form-group align="left" v-if="objGuardar.tieneEscanerLaboratorio">
                  <label>¿Qué escáner tiene?
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        label="nombreEscaner"
                        id="idEscaner"
                        :options="escaneresFiltro"
                        :reduce="(val) => val.idEscaner"
                        v-model="$v.objGuardar.idEscanerLaboratorio.$model"
                        placeholder="Escaner en clinica"
                        :filterable="false"
                        @search="filtroEscaneres"
                    ></v-select>
                    <validacion
                        v-if="$v.objGuardar.tieneEscanerLaboratorio.$model === true && $v.objGuardar.idEscanerLaboratorio.$dirty && ($v.objGuardar.idEscanerLaboratorio.$invalid || $v.objGuardar.idEscanerLaboratorio.$error === 'true')"
                        texto="Selecciona un escaner"/>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <div class="mt-2 col-md-12"></div>

            </b-row>
              <b-row>
                <b-col cols="12">
                  <legend>Métodos de pago</legend>
                  <b-row align-v="center" cols="1" cols-md="2" cols-lg="3">

                    <b-col>
                      <div class="formularios marginformularios"
                           style="display:flex;align-items:center">
                        <label class="bold marginlabel"
                               style="margin-top:5px"
                        >Mercado pago</label>
                        <b-form-checkbox
                            id="mercadoComp"
                            class="formularios marginformularios"
                            v-model="$v.objGuardar.blnMercadoPago.$model"
                            :state="validateState('blnMercadoPago')"
                            value="true"
                            unchecked-value="false"
                            switch
                        ></b-form-checkbox>
                      </div>
                    </b-col>

                    <b-col>
                      <div class="formularios marginformularios"
                           style="display:flex;align-items:center">
                        <label class="bold marginlabel"
                               style="margin-top:5px"
                        >Transferencia</label>
                        <b-form-checkbox
                            id="transfComp"
                            class="formularios marginformularios"
                            v-model="$v.objGuardar.blnTransferenciaElectronica.$model"
                            :state="validateState('blnTransferenciaElectronica')"
                            value="true"
                            unchecked-value="false"
                            switch
                        ></b-form-checkbox>
                      </div>
                    </b-col>

                    <b-col>
                      <div class="formularios marginformularios"
                           style="display:flex;align-items:center">
                        <label class="bold marginlabel"
                               style="margin-top:5px"
                        >Sección niños</label>
                        <b-form-checkbox
                            id="ninosComp"
                            class="formularios marginformularios"
                            v-model="$v.objGuardar.blnSeccionNinos.$model"
                            :state="validateState('blnSeccionNinos')"
                            value="true"
                            unchecked-value="false"
                            switch
                        ></b-form-checkbox>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>

                <div class="mt-2 col-md-12"></div>
              </b-row>
            </div>
          </b-tab>

          <b-tab class="p-0">
            <template #title>
              Datos de Contacto
              <em class="admiracion" variant="danger" v-show="tab2Vacio" ></em>
            </template>

            <b-row>
              <b-col>
                <p style="color: #17a2b8; font-weight: 600" class="mt-2">Datos de Contacto</p>
              </b-col>
            </b-row>
            <div class="scrollPorTabs">
<!--              <b-row align-v="center">
                <b-col>
                  <validacion/>
                  Únicamente para recordarte citas ó enviarte información de tratamientos
                </b-col>
              </b-row>-->
              <b-row cols="1" cols-md="2" cols-lg="4" class="mr-3">
                <b-col>
                  <b-form-group align="left">
                    <label>Calle
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          id="strMapaComp"
                          placeholder="Ingresa la calle"
                          :state="validateState('calle')"
                          v-model="$v.objGuardar.calle.$model"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Número exterior
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          id="sistemicaComp"
                          placeholder="Ingresa el número exterior"
                          :state="validateState('noExterior')"
                          v-model="$v.objGuardar.noExterior.$model"
                          type="number"
                          min="0"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Número interior
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          id="noInteriorComp"
                          placeholder="Ingresa número de interior"
                          :state="validateState('noInterior')"
                          v-model="$v.objGuardar.noInterior.$model"
                          type="number"
                          min="0"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Pais
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          id="paisComp"
                          placeholder="Pais: México"
                          disabled
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Código postal
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="name"
                          id="codigopostal"
                          class="botonesformularios"
                          :filterable="false"
                          :options="opcionesCodigoPostal"
                          @search="consultarCP"
                          :reduce="(cp) => cp.id"
                          v-model="$v.objGuardar.codigoPostal.$model"
                          :state="validateState('codigoPostal')"
                          placeholder="Ingresa el código postal"
                      >
                        <template slot="no-options">Sin datos</template>
                      </v-select>
                      <validacion
                          v-if="$v.objGuardar.codigoPostal.$dirty && ($v.objGuardar.codigoPostal.$invalid || $v.objGuardar.codigoPostal.$error == 'true')"
                          texto="Escriba un código postal"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Estado
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="idEstadoComp"
                          :options="opcionesEstados"
                          :reduce="(val) => val.text"
                          v-model="$v.objGuardar.nombreEstado.$model"
                          placeholder="Selecciona un estado"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.nombreEstado.$dirty && ($v.objGuardar.nombreEstado.$invalid || $v.objGuardar.nombreEstado.$error == 'true')"
                          texto="Selecciona un estado"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Delegación/Municipio
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="idMunicipioComp"
                          :options="opcionesMunicipios"
                          :reduce="(val) => val.text"
                          v-model="$v.objGuardar.municipio.$model"
                          placeholder="Selecciona un municipio"

                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.municipio.$dirty && ($v.objGuardar.municipio.$invalid || $v.objGuardar.municipio.$error == 'true')"
                          texto="Selecciona un municipio"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Colonia
                      <validacion/>
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <v-select
                          style="width: 100%;"
                          label="text"
                          id="coloniaComp"
                          :options="opcionesColonia"
                          :reduce="(val) => val.text"
                          v-model="$v.objGuardar.colonia.$model"
                          placeholder="Selecciona una colonia"
                      ></v-select>
                      <validacion
                          v-if="$v.objGuardar.colonia.$dirty && ($v.objGuardar.colonia.$invalid || $v.objGuardar.colonia.$error == 'true')"
                          texto="Selecciona una colonia"/>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Teléfono 1</label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          id="numerocelular"
                          placeholder="Ingresa el télefono 1"
                          v-mask="'(###) - ### - ####'"
                          v-model="$v.objGuardar.tel1.$model"
                          :state="validateState('tel1')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Teléfono 2</label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          id="numerocelular"
                          placeholder="Ingresa el télefono 2"
                          v-mask="'(###) - ### - ####'"
                          v-model="$v.objGuardar.tel2.$model"
                          :state="validateState('tel2')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group align="left">
                    <label>Teléfono 3</label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          id="numerocelular"
                          placeholder="Ingresa el télefono 3"
                          v-mask="'(###) - ### - ####'"
                          v-model="$v.objGuardar.tel3.$model"
                          :state="validateState('tel3')"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <label>Url Google Maps</label>
                  <b-form-textarea
                      style="resize:both; height: 90px; width: 90%;"
                      id="textarea"
                      placeholder="Ingresa la url del Google Maps"
                      rows="3"
                      max-rows="6"
                      v-model="$v.objGuardar.maps.$model"
                  ></b-form-textarea>
                </b-col>
                <b-col>
                  <label>Croquis</label>

                  <div>
                    <div v-if="clinicaOriginal.urlCroquis === null && imagenCargada === null">
                    <input type="file" ref="inputArchivo" accept="image/*,.jpg,.jpeg,.png"  @change="cargarArchivo($event)" style="display: none;">
                    <b-button variant="outline-primary" class="rounded-pill" size="sm" @click="$refs.inputArchivo.click()">
                      <span style="color: #2981C4"></span> Agregar imagen
                    </b-button>
                    </div>
                    <div class="m-5 text-center d-flex justify-content-center" v-if="clinicaOriginal.urlCroquis === null ">
                      <label for="imagen" v-if="imagenCargada === null">Sin imagen seleccionada </label>
                      <div v-else style="position: relative">
                        <em class="circle_close" @click="eliminarImagen()" style="position: absolute; top: -20px; cursor: pointer" v-b-tooltip.hover.top.v-light title="Eliminar imagen"></em>
                        <img :src="imagenCargada.url" id="imgPreview" alt="imgEvidencia" style="max-width: 100%;"/>
                      </div>
                    </div>
                    <div v-else>
                      <em class="circle_close" @click="eliminarImagen()" style="position: absolute; top: 24px; cursor: pointer" v-b-tooltip.hover.top.v-light title="Eliminar imagen"></em>
                      <img :src="clinicaOriginal.urlCroquis" id="imgPreview" alt="imgEvidencia" style="max-width: 100%;"/>
                    </div>
                  </div>

                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab class="p-0">
            <template #title>
              Horario de Apertura
              <em class="admiracion" variant="danger" v-show="tab3Vacio" ></em>
            </template>

            <b-row>
              <b-col>
                <p style="color: #17a2b8; font-weight: 600" class="mt-2">Horario de Apertura</p>
              </b-col>
            </b-row>
            <div class="scrollPorTabs">
<!--              <b-row align-v="center">
                <b-col>
                  <validacion/>
                  Seleccionar un horario de apertura y un horario de cierre
                </b-col>
              </b-row>-->
              <b-row cols="1" cols-lg="2" class="mr-3">
                <b-col>
                  <b-form-group align="left">
                    <div class="mb-3" v-for="(day, index) in diasSemana" :key="index">
                      <div v-if="index < 5">
                        <div class="row col-3">{{day.day}}</div>
                        <div v-for="(horario,indexhora) in day.horarios" :key="'hora'+ index + indexhora">
                          <vue-timepicker v-model="horario.start_time" placeholder="Hora inicio"></vue-timepicker>
                          <span > a </span>
                          <vue-timepicker v-model="horario.end_time" placeholder="Hora cierre" ></vue-timepicker>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group align="left">
                    <div class="mb-3" v-for="(day, index) in diasSemana" :key="index">
                      <div v-if="index > 4">
                        <div class="row col-3">{{day.day}}</div>
                        <div v-for="(horario,indexhora) in day.horarios" :key="'hora'+ index + indexhora">
                          <vue-timepicker v-model="horario.start_time" placeholder="Hora inicio"></vue-timepicker>
                          <span > a </span>
                          <vue-timepicker v-model="horario.end_time" placeholder="Hora cierre"></vue-timepicker>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <b-button v-show="false" id="submitGuardar" ref="submitGuardar" type="submit" style="visibility: hidden" v-if="$localStorageService.can('BO_28_clini_Alta') || $localStorageService.can('BO_28_clini_Act_Edit_Elim')"></b-button>
    </b-form>
  </div>
</template>

<script>
import "vue-datetime/dist/vue-datetime.css";
import {validationMixin} from "vuelidate";
import {required, minLength, maxLength} from "vuelidate/lib/validators";

/*import {S3Client} from "@aws-sdk/client-s3";
import {Upload} from "@aws-sdk/lib-storage";*/
import {AwsService} from "@/apiServices/aws/AwsService";

export default {
  name: "altaClinicaV2",

  components: {

  },
  props:{
    mostrarGuardar: Boolean,
    clinicaOriginal: Object
  },

  mixins: [validationMixin],

  data(){
    return {
      awsServicio: new AwsService(),
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      mostrarModal: false,

      opcionesUbicaciones: [],
      opcionesUbicacionesFiltro: [],
      opcionesZonas: [],
      opcionesZonasFiltro: [],
      opcionesPrecios: [],
      opcionesPreciosFiltro: [],
      opcionesTiposSDI: [],
      opcionesTiposSDIFiltro: [],
      opcionesTipoClinica: [],
      opcionesTipoClinicaFiltro: [],
      opcionesEstados: [],
      opcionesMunicipios: [],
      opcionesColonia: [],
      opcionesCodigoPostal: [],
      opcionesCategoriaClinica:[],
      opcionesCategoriaClinicaFiltro:[],
      opcionesZonasHorarias:[],
      opcionesZonasHorariasFiltro:[],

      diasSemana:[
        {day: 'Lunes',value:1,horarios:[]},
        {day: 'Martes',value:2,horarios:[]},
        {day: 'Miércoles',value:3,horarios:[]},
        {day: 'Jueves',value:4,horarios:[]},
        {day: 'Viernes',value:5,horarios:[]},
        {day: 'Sábado',value:6,horarios:[]},
        {day: 'Domingo',value:7,horarios:[]}
      ],

      escaneres: [],
      escaneresFiltro: [],
      objGuardar: {
        idClinica: null,
        strNombre: null,
        strNombreCorto: null,
        numeroSillones: null,
        capacidad:null,
        strLatitud: 0,
        strLongitud: 0,
        blnWeb: false,
        idPrecio: null,
        idUbicacion: null,
        idZona: null,
        idKcli: null,
        kRegion: null,
        kunitProd: null,
        kSubClient: null,
        idTipoClinica: null,
        idCategoria: null,
        strRFC: null,
        blnMercadoPago: false,
        blnTransferenciaElectronica: false,
        blnSeccionNinos: false,
        idCrm: null,
        idTipoSdi: null,
        codigoPostal: null,
        calle: null,
        noExterior: null,
        noInterior: null,
        nombreEstado: null,
        municipio: null,
        colonia: null,
        tel1: null,
        tel2: null,
        tel3: null,
        maps: null,
        blnTurismoMedico: false,
        strMapa: '',
        blnRegistraIngresos: false,
        prueba:null,
        escanerFits: false,
        tieneEscanerLaboratorio: false,
        idEscanerLaboratorio: null,
        dias: [
          {start_time: '00:00', end_time: '23:59',day: 'Lunes',value:1},
          {start_time: '00:00', end_time: '23:59',day: 'Martes',value:2},
          {start_time: '00:00', end_time: '23:59',day: 'Miercoles',value:3},
          {start_time: '00:00', end_time: '23:59',day: 'Jueves',value:4},
          {start_time: '00:00', end_time: '23:59',day: 'Viernes',value:5},
          {start_time: '00:00', end_time: '23:59',day: 'Sabado',value:6},
          {start_time: '00:00', end_time: '23:59',day: 'Domingo',value:7}
        ],
      },
      tab1Vacio: false,
      tab2Vacio: false,
      tab3Vacio: false,

      imagenCargada: null,
    };
  },
  validations() {
    if(this.objGuardar.tieneEscanerLaboratorio){
      return{
        objGuardar: {
          strNombre: {required, maxLength: maxLength(100)},
          strNombreCorto: {required, maxLength: maxLength(70)},
          numeroSillones: {required, maxLength: maxLength(5)},
          capacidad: {required, maxLength: maxLength(5)},
          strLatitud: {required, maxLength: maxLength(25)},
          strLongitud: {required, maxLength: maxLength(25)},
          blnWeb: {},
          idPrecio: {required},
          idUbicacion: {required},
          idZona: {required},
          idZonaHoraria: {required},
          idKcli: {required, maxLength: maxLength(5)},
          kRegion: {required, maxLength: maxLength(3)},
          kunitProd: {required, maxLength: maxLength(3)},
          kSubClient: {required, maxLength: maxLength(7)},
          idTipoClinica: {required},
          idCategoria:{required},
          strRFC: {required, maxLength: maxLength(20)},
          blnMercadoPago: {required},
          blnTransferenciaElectronica: {required},
          blnSeccionNinos: {required},
          idCrm: {required, maxLength: maxLength(50)},
          idTipoSdi: {required},
          codigoPostal: {required},
          calle: {required, maxLength: maxLength(100)},
          noExterior: {required, maxLength: maxLength(50)},
          noInterior: {required, maxLength: maxLength(50)},
          nombreEstado: {required},
          municipio: {required},
          colonia: {required},
          tel1: {required, minLength: minLength(18), maxLength: maxLength(18)},
          tel2: {minLength: minLength(18), maxLength: maxLength(18)},
          tel3: {minLength: minLength(18), maxLength: maxLength(18)},
          blnRegistraIngresos: {},
          escanerFits: {},
          tieneEscanerLaboratorio: {},
          idEscanerLaboratorio: {required},
          maps: {required},
        }
      }
    }else{
      return {
        objGuardar: {
          strNombre: {required, maxLength: maxLength(100)},
          strNombreCorto: {required, maxLength: maxLength(70)},
          numeroSillones: {required, maxLength: maxLength(5)},
          capacidad: {required, maxLength: maxLength(5)},
          strLatitud: {required, maxLength: maxLength(25)},
          strLongitud: {required, maxLength: maxLength(25)},
          blnWeb: {},
          idPrecio: {required},
          idUbicacion: {required},
          idZona: {required},
          idZonaHoraria: {required},
          idKcli: {required, maxLength: maxLength(5)},
          kRegion: {required, maxLength: maxLength(3)},
          kunitProd: {required, maxLength: maxLength(3)},
          kSubClient: {required, maxLength: maxLength(7)},
          idTipoClinica: {required},
          idCategoria:{required},
          strRFC: {required, maxLength: maxLength(20)},
          blnMercadoPago: {required},
          blnTransferenciaElectronica: {required},
          blnSeccionNinos: {required},
          idCrm: {required, maxLength: maxLength(50)},
          idTipoSdi: {required},
          codigoPostal: {required},
          calle: {required, maxLength: maxLength(100)},
          noExterior: {required, maxLength: maxLength(50)},
          noInterior: {required, maxLength: maxLength(50)},
          nombreEstado: {required},
          municipio: {required},
          colonia: {required},
          tel1: {required, minLength: minLength(18), maxLength: maxLength(18)},
          tel2: {minLength: minLength(18), maxLength: maxLength(18)},
          tel3: {minLength: minLength(18), maxLength: maxLength(18)},
          blnRegistraIngresos: {},
          escanerFits: {},
          tieneEscanerLaboratorio: {},
          idEscanerLaboratorio: {},
          maps: {},
        }
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.cargarCatalogos();
    this.$nextTick(() => {
      this.$v.$reset()
    });
    this.crearClinica();
    if (!this.mostrarGuardar) {
      this.inicializar();
    }
  },
  methods: {
    cargarArchivo(e) {
      const files = e.target.files || e.dataTransfer.files;
      const file = files[0];

      if (!file) return;

      // Validar extensiones de imagen
      const validExtensions = ['jpg', 'jpeg', 'png'];
      const extension = file.name.split('.').pop().toLowerCase();

      if (!validExtensions.includes(extension)) {
        this.$swal.fire({
          icon: "error",
          /*title: "Aviso",*/
          text: "Por favor, sube solo imágenes (JPG, PNG, JPEG)",
        });
        return;
      }

      // Crear URL temporal para la previsualización
      const objectUrl = URL.createObjectURL(file);


      this.imagenCargada = {
        file: file,
        url: objectUrl, // Guardamos la URL temporal
        nombreArchivo: `${this.clinicaOriginal.idClinica}`,
        extension: extension,
      };
      this.$refs.inputArchivo.value = '';

      console.log("imagen", this.imagenCargada)
    },

    async convertirA_Base64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64ConPrefijo = reader.result;
          const base64SinPrefijo = base64ConPrefijo.split(',')[1]; // Quita "data:image/...;base64,"
          resolve(base64SinPrefijo);
        };
        reader.onerror = error => reject(error);
      });
    },
    eliminarImagen() {
      if (this.imagenCargada !== null){
        URL.revokeObjectURL(this.imagenCargada.url); // libera memoria
        this.imagenCargada = null;
      }
      if (this.clinicaOriginal.urlCroquis !== null){
        this.clinicaOriginal.urlCroquis = null;
      }

    },
    mapearDias(){

      if (this.objGuardar.dias.length === 0){
        this.objGuardar.dias = [
          {start_time: '0', end_time: '2359',day: 'Lunes',value:1},
          {start_time: '0', end_time: '2359',day: 'Martes',value:2},
          {start_time: '0', end_time: '2359',day: 'Miercoles',value:3},
          {start_time: '0', end_time: '2359',day: 'Jueves',value:4},
          {start_time: '0', end_time: '2359',day: 'Viernes',value:5},
          {start_time: '0', end_time: '2359',day: 'Sabado',value:6},
          {start_time: '0', end_time: '2359',day: 'Domingo',value:7}
        ]
      }


      this.objGuardar.dias.forEach(di=>{
        this.diasSemana.forEach(diase=>{
          if(di.value === diase.value){
            const item = JSON.parse(JSON.stringify(di));
            item.start_time = this.$options.filters.formatoHoraDeEntero(item.start_time)
            item.end_time = this.$options.filters.formatoHoraDeEntero(item.end_time)
            diase.horarios.push(item);

          }
        });
      });
    },

    async inicializar() {
      await this.obtenerConfiguracionesClinica();
      await this.obtenerConfiguracionesCatalogo();
    },
    async obtenerConfiguracionesCatalogo() {
      await this.$http.get(this.$api + "configuracionClinica/obtenerConfiguracionesClinicaEce").then(response => {
            if (response.data.data) {
              this.configuracionBase = response.data.data;
              this.initConfiguracionesEdit();
            }
          }
      )
    },
    async obtenerConfiguracionesClinica(){
      const parametros = {idClinica: this.clinicaOriginal.idClinica}
      await this.$http.post(this.$api + "configuracionClinica/obtenerConfiguracionesPorIdClinica", parametros).then(response => {
            if (response.data.data) {
              this.configuraciones = response.data.data;
            }
          }
      )
    },
    activarDesactivarConfiguracion(config) {
      this.configuraciones.map((c)=>{
        if(c.idConfiguracionClinica === config.idConfiguracionClinica){
          config['idRConfiguracion'] = c.idRConfiguracion;
        }
      });
      const estatusActual = config.activo;
      config.activo = !config.activo;
      config.disabled = true;
      config['idClinica'] = this.clinicaOriginal.idClinica;
      this.$forceUpdate();
      this.$http.post(this.$api + 'configuracionClinica/guardarConfiguracionClinica', config).then(respuesta => {

        this.$bvToast.toast(respuesta.data.message, {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })

      }).catch(error => {
        console.error(error.data);
        this.$bvToast.toast("Ocurrio un error al realizar la asignación", {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })

        config.activo = estatusActual;
      }).finally(() => {
        config.disabled = false;
        this.$forceUpdate();
      });
    },
    initConfiguracionesEdit() {
      this.configuracionBase.forEach(it => {
        it.disabled=false;
        it.activo=this.configuraciones.some((idp) => idp.idConfiguracionClinica === it.idConfiguracionClinica);
        it.r
      });
    },

    filtroEscaneres(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.escaneresFiltro = this.escaneres.filter(em => {
        return em.nombreEscaner.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesZonasHorarias(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesZonasHorariasFiltro = this.opcionesZonasHorarias.filter(em => {
        return em.nombreZona.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesCategoriaClinica(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesCategoriaClinicaFiltro = this.opcionesCategoriaClinica.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesTipoClinica(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTipoClinicaFiltro = this.opcionesTipoClinica.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesTiposSDI(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesTiposSDIFiltro = this.opcionesTiposSDI.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesPrecios(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesPreciosFiltro = this.opcionesPrecios.filter(em => {
        return em.nombreZona.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesUbicaciones(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesUbicacionesFiltro = this.opcionesUbicaciones.filter(em => {
        return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    filtroOpcionesZonas(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.opcionesZonasFiltro = this.opcionesZonas.filter(em => {
        return em.zona_nombre.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },


    validateState(name) {
      const {$dirty, $error} = this.$v.objGuardar[name];
      return $dirty ? !$error : null;
    },
    cargarCatalogos() {
      this.opcionesUbicaciones = [];
      this.opcionesZonas = [];
      this.opcionesPrecios = [];
      this.opcionesTiposSDI = [];
      this.opcionesTipoClinica = [];
      this.opcionesCategoriaClinica=[];
      this.opcionesZonasHorarias=[];

      this.$http.get(this.$api + "catalogos/obtenerUbicaciones").then(response => {
            if (response.data.data) {
              this.opcionesUbicaciones = response.data.data
              this.opcionesUbicacionesFiltro = this.opcionesUbicaciones;
            }
          }
      )

      this.$http.get(this.$api + "catalogos/listaZonas").then(response => {
            if (response.data.data) {
              this.opcionesZonas = response.data.data
              this.opcionesZonasFiltro = this.opcionesZonas;
            }
          }
      )

      this.$http.get(this.$api + "catalogos/listaPrecios").then(response => {
            if (response.data.data) {
              this.opcionesPrecios = response.data.data
              this.opcionesPreciosFiltro = this.opcionesPrecios;
            }
          }
      )

      this.$http.get(this.$api + "catalogos/obtenerTiposSDI").then(response => {
            if (response.data.data) {
              this.opcionesTiposSDI = response.data.data
              this.opcionesTiposSDIFiltro =  this.opcionesTiposSDI;
            }
          }
      )

      this.$http.get(this.$api + "catalogos/obtenerTipoClinicas").then(response => {
            if (response.data.data) {
              this.opcionesTipoClinica = response.data.data
              this.opcionesTipoClinicaFiltro = this.opcionesTipoClinica;
            }
          }
      )
      this.$http.get(this.$api + "catalogos/obtenerCategoriasClinicasAAA").then(response => {
            if (response.data.data) {
              this.opcionesCategoriaClinica = response.data.data
              this.opcionesCategoriaClinicaFiltro = this.opcionesCategoriaClinica;
            }
          }
      )
      this.$http.get(this.$api + "catalogos/listaZonasHorarias").then(response => {
            if (response.data.data) {
              this.opcionesZonasHorarias = response.data.data
              this.opcionesZonasHorariasFiltro =   this.opcionesZonasHorarias;
            }
          }
      )

      this.$http.post(this.$api + "catalogo/escaner/obtenerEscanerClinica").then(response => {
            if (response.data.data) {
              this.escaneres = response.data.data
              this.escaneresFiltro =   this.escaneres;
            }
          }
      )

    },
    consultarCP(searchTerm) {
      var _this = this;
      if (searchTerm === "") {
        return false;
      }
      if (searchTerm != undefined) {
        var inputTxt = searchTerm;
        const params = {
        codigoPostal: inputTxt
      }
        this.$http
            .post(this.$api + "localidad/postales", params)
            .then((response) => {
              if (response.status === 200) {
                if (Array.isArray(response.data.data) == true) {
                  const uniqueAddresses = Array.from(
                      new Set(response.data.data.map((a) => a.idLocalidad))
                  ).map((idLocalidad) => {
                    return response.data.data.find(
                        (a) => a.idLocalidad === idLocalidad
                    );
                  });
                  _this.opcionesColonia = [];
                  _this.opcionesEstados = [];
                  _this.opcionesMunicipios = [];
                  this.opcionesCodigoPostal = [];
                  uniqueAddresses.forEach((element) => {
                    this.opcionesCodigoPostal.push({
                      id: element.codigoPostal,
                      name: element.codigoPostal,
                    });
                  });
                  let tempcodigopostal = this.opcionesCodigoPostal.filter(
                      (v, i, a) =>
                          a.findIndex(
                              (t) => t.label === v.label && t.value === v.value
                          ) === i
                  );
                  this.opcionesCodigoPostal = tempcodigopostal;

                  if (this.opcionesCodigoPostal.length == 1) {
                    this.objGuardar.codigoPostal = this.opcionesCodigoPostal[0].id;
                  } else {
                    this.objGuardar.codigoPostal = null;
                  }

                  var i = 0;
                  response.data.data.forEach(function (item) {
                    i++;
                    let itemcolonia = {
                      value: i,
                      text: item.nombreLocalidad,
                    };
                    _this.opcionesColonia.push(itemcolonia);
                    let itemdelegacionmunicipio = {
                      value: i,
                      text: item.nombreMunicipio,
                    };
                    let itemestado = {
                      value: i,
                      text: item.nombreEstado,
                    };
                    _this.opcionesEstados.push(itemestado);
                    _this.opcionesMunicipios.push(
                        itemdelegacionmunicipio
                    );
                  });

                  let tempdelegacionmunicipio = _this.opcionesMunicipios.filter(
                      (v, i, a) => a.findIndex((t) => t.id === v.id) === i
                  );
                  let tempestado = _this.opcionesEstados.filter(
                      (v, i, a) => a.findIndex((t) => t.id === v.id) === i
                  );

                  _this.opcionesMunicipios = tempdelegacionmunicipio;
                  _this.opcionesEstados = tempestado;


                  if (_this.opcionesEstados.length === 1) {
                    _this.objGuardar.nombreEstado = _this.opcionesEstados[0].text;
                  }
                  if (_this.opcionesMunicipios.length === 1) {
                    _this.objGuardar.municipio = _this.opcionesMunicipios[0].text;
                  }
                  if (_this.opcionesColonia.length > 0) {
                    _this.objGuardar.colonia = _this.opcionesColonia[0].text;
                  }
                }
              }
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {});
      }
    },
    crearClinica() {
      if (this.mostrarGuardar) {

        this.diasSemana = [
          {day: 'Lunes',value:1,horarios:[{start_time: '00:00', end_time: '23:59'}]},
          {day: 'Martes',value:2,horarios:[{start_time: '00:00', end_time: '23:59'}]},
          {day: 'Miércoles',value:3,horarios:[{start_time: '00:00', end_time: '23:59'}]},
          {day: 'Jueves',value:4,horarios:[{start_time: '00:00', end_time: '23:59'}]},
          {day: 'Viernes',value:5,horarios:[{start_time: '00:00', end_time: '23:59'}]},
          {day: 'Sábado',value:6,horarios:[{start_time: '00:00', end_time: '23:59'}]},
          {day: 'Domingo',value:7,horarios:[{start_time: '00:00', end_time: '23:59'}]}
        ]


      } else {
        this.clinicaOriginal.municipio = null;
        this.objGuardar = JSON.parse(JSON.stringify(this.clinicaOriginal));
        this.mapearDias();
        this.consultarCP(this.objGuardar.codigoPostal);
      }
    },
    filtrarTabInvalido() {
      if (this.$v.objGuardar.strNombre.$invalid ||
          this.$v.objGuardar.strNombreCorto.$invalid ||
          this.$v.objGuardar.numeroSillones.$invalid ||
          this.$v.objGuardar.capacidad.$invalid ||
          this.$v.objGuardar.idCrm.$invalid ||
          this.$v.objGuardar.idTipoSdi.$invalid ||
          this.$v.objGuardar.strLatitud.$invalid ||
          this.$v.objGuardar.strLongitud.$invalid ||
          this.$v.objGuardar.idPrecio.$invalid ||
          this.$v.objGuardar.idUbicacion.$invalid ||
          this.$v.objGuardar.idZona.$invalid ||
          this.$v.objGuardar.idKcli.$invalid ||
          this.$v.objGuardar.kRegion.$invalid ||
          this.$v.objGuardar.kunitProd.$invalid ||
          this.$v.objGuardar.kSubClient.$invalid ||
          this.$v.objGuardar.idTipoClinica.$invalid ||
          this.$v.objGuardar.strRFC.$invalid ||
          this.$v.objGuardar.idCategoria.$invalid ||
          this.$v.objGuardar.idZonaHoraria.$invalid)
      {
        this.tab1Vacio = true;
      }

      if (this.$v.objGuardar.calle.$invalid ||
          this.$v.objGuardar.noExterior.$invalid ||
          this.$v.objGuardar.noInterior.$invalid ||
          this.$v.objGuardar.codigoPostal.$invalid ||
          this.$v.objGuardar.nombreEstado.$invalid ||
          this.$v.objGuardar.strLatitud.$invalid ||
          this.$v.objGuardar.strLongitud.$invalid ||
          this.$v.objGuardar.idPrecio.$invalid ||
          this.$v.objGuardar.municipio.$invalid ||
          this.$v.objGuardar.colonia.$invalid ||
          this.$v.objGuardar.tel1.$invalid ||
          this.$v.objGuardar.tel2.$invalid ||
          this.$v.objGuardar.tel3.$invalid)
      {
        this.tab2Vacio = true;
      }
    },

    async guardar() {

      this.$v.objGuardar.$touch();
      this.tab1Vacio = false;
      this.tab2Vacio = false;
      if (this.$v.objGuardar.$anyError) {
        this.filtrarTabInvalido();
        return;
      }

      this.objGuardar.opcionGuardar = 1;
      if (this.imagenCargada != null){
      const imagenCroquis = await this.convertirA_Base64(this.imagenCargada.file)
        this.objGuardar.imagenCroquis = imagenCroquis
      }


     // await this.guardarArchivos();

      this.loading = true;
      this.$http
          .post(this.$api + "catalogos/crearClinica", this.datosEnvio())
          .then((response) => {
            if (response.status === 200) {
              this.$swal.fire({
                position: "center",
                icon: "success",
                title: "Clinica registrada correctamente ",
                showConfirmButton: false,
                timer: 3500,
              });

              this.$nextTick(() => {
                this.$v.$reset()
              });

              
              this.$emit("actualizar", this.objGuardar.strNombre);
              this.objGuardar = {};
            }
          }).catch((error)=>{
        console.error(error);
        this.$swal.fire({
          position: "center",
          icon: "error",
          title: "Ocurrio un error al registrar la clínica",
          showConfirmButton: false,
          timer: 3500,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    datosEnvio(){

      const params = JSON.parse(JSON.stringify(this.objGuardar))

      params.dias = []
      this.diasSemana.filter(ds => {
        ds.horarios.forEach(h => {

          const dato = {
            start_time: h.start_time,
            end_time: h.end_time,
            day: ds.day,
            value: ds.value,
            idClinicaHorario: h.idClinicaHorario
          }
          params.dias.push(dato)
        })
      })

      return params
    }
  },
}
;
</script>

<style scoped>

.redondeo{
  border-radius: 10px !important;
}


b-form-checkbox[class="blue"] + span::before
{
  border: solid 1px blue;
  background: #B2DBFF;
  background: -moz-radial-gradient(#B2DBFF, #dfdfdf);
  background: -webkit-radial-gradient(#B2DBFF, #dfdfdf);
  background: -ms-radial-gradient(#B2DBFF, #dfdfdf);
  background: -o-radial-gradient(#B2DBFF, #dfdfdf);
  background: radial-gradient(#B2DBFF, #dfdfdf);
}


.scrollPorTabs {
  height:47vh;
  overflow-y: scroll;
  overflow-x: hidden
}
</style>
